import { createContext } from 'react';

const PresentationContext = createContext();
PresentationContext.displayName = 'PresentationContext';

export default PresentationContext;
